import React, { Component } from 'react';
import './securityCaller.css';
import { Grid, Row } from 'react-bootstrap';
import { setData, setErrorType, setShowError } from "../../redux/actionCreators";
import { connect } from "react-redux";
import config from '../../config/config'


class SecurityCaller extends Component {
    options = () => {
        const options = {
            locale: "es",
            session_id: this.props.stepInfo.securityCallerData ? this.props.stepInfo.securityCallerData.TOC_SESSION_ID : null,
            callback: async (captured_token, image, data) => {
                this.props.setData(this.keysData(captured_token, image, data));
                this.props.nextStep();
            },
            failure: (error) => {
                console.log('TOC error: ', error);
                let errType = parseInt(error,10);
                errType = !isNaN(errType) && this.props.processType ? `${this.props.processType.toUpperCase()}_${errType}` : 'default';
                const temp = new URLSearchParams(window.location.search)
                if (temp.get('testing') && temp.get('errorCode')) {
                    errType = temp.get('errorCode');
                }
                this.props.setErrorType(errType);
                this.props.setShowError(true);
            }
        }
        if (this.props.processType === 'autocapture') {
            options.document_type = this.props.stepInfo.securityCallerData ? this.props.stepInfo.securityCallerData.IDENTITY_CARD_TYPE : null;
            options.document_side = this.props.cardSide;
            if (config.autocapture_alt_server) {
                options.alt_server = config.autocapture_alt_server;
            }
            if (config.autocapture_url_lbac) {
                options.url_lbac = config.autocapture_url_lbac;
            }
        } else {
            if (config.liveness_alt_server) {
                options.alt_server = config.liveness_alt_server;
            }
            if (config.liveness_url_lbliv) {
                options.url_lbliv = config.liveness_url_lbliv;
            }
        }

        return options
    }

    keysData = (captured_token, image, data) => {
        if (this.props.processType === 'autocapture') {
            return {
                [`IDENTITY_CARD_${this.props.cardSide.toUpperCase()}`]: image,
                [`IDENTITY_CARD_${this.props.cardSide.toUpperCase()}_CAPTURE_DATA`]: JSON.stringify(data),
                [`IDENTITY_CARD_${this.props.cardSide.toUpperCase()}_CAPTURE_TOKEN`]: captured_token,
            }
        } else {
            return {
                'FACE_PHOTO': image,
                'FACE_LIVENESS_DATA': JSON.stringify(data),
                'FACE_LIVENESS_TOKEN': captured_token,
            }
        }
    }

    validateDeniedPermissions = async(constraints) => {
        let deniedPermissions = false;
        try {
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            if (stream) {
                stream.getTracks().forEach(function(track) {
                    track.stop();
                });
            }
        } catch (error) {
            console.error('Error validate denied permissions: ', error);
            deniedPermissions = true;
        }
        return deniedPermissions;
    }

    async componentDidMount() {
        const processType = this.props.processType;
        let deniedPermissions = await this.validateDeniedPermissions({ video: true });
        if (deniedPermissions) {
            this.props.setErrorType(`${processType.toUpperCase()}_409`);
            this.props.setShowError(true);
            return;
        }
        const script = document.createElement("script");
        if (processType === 'autocapture') {
            script.src = config.autocapture_library;
            script.onload = () => {
                window.TOCautocapture && window.TOCautocapture('security', this.options());
            }
        } else {
            script.src = config.liveness_library;
            script.onload = () => {
                window.TOCliveness && window.TOCliveness('security', this.options());
            }
        }
        script.async = true;
        document.head.appendChild(script);
    }

    render() {
        return (
            <Grid>
                <div className={'toc-black-background'}></div>
                <div className={'content'}>
                    <Row>
                        <div id={'security'}>
                        </div>
                    </Row>
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        loader: state.loader,
        showError: state.showError,
        errorType: state.errorType,
        stepData: state.stepData,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setData(data) {
            dispatch(setData(data));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityCaller);
